import type { WorkspaceContext } from './canvas-types';

/** Read durable UI experience metadata without inferring intent from text or suggestions. */
export function conversationWorkspaceContext(history: ReadonlyArray<{ workspaceContext?: unknown }>, fallback: WorkspaceContext): WorkspaceContext {
  let result = fallback;
  for (const row of history) {
    const context = row.workspaceContext as Partial<WorkspaceContext> | undefined;
    if (context?.entryMode !== 'agent' && context?.entryMode !== 'create-ad') continue;
    result = { entryMode: context.entryMode, creativeActivated: result.creativeActivated || context.creativeActivated === true };
  }
  return result;
}
